export default "__VITE_ASSET__Ce81KZuV__"